import { cx } from '@linaria/core';
import { useRef } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { useKatex } from '@pm2/react-utils';
import { breakpoints } from '@ui/css';
import { LinkButton, IconButton, EnterFullscreenIcon, ExitFullscreenIcon } from '@ui/kit';
import { useMatchBreakpoint, useFullscreenState, useElementSize, SizeTransition } from '@utils/react';
import { useFinishAction } from '../../../state/actions/finish.js';
import { useOpgavekompleksetComponent } from '../../../state/context.data.js';
import { getTaskTitle } from '../../../utils/get-task-title.js';
import { Progress } from '../../atom.progress/atom.progress.js';
import { useMatchTaskBreakpoint, taskBreakpoints } from '../hook.task-breakpoints.js';
import { taskHeaderSize, header, progress, headingWrapper, transitionDurationMs, heading, tools, finishButton } from './_task-header.style.js';
import { useOpgavekompleksetFullscreenActions } from './hook.fullscreen.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

function TaskHeader(props) {
  const {
    withProgress: externalWithProgress = true
  } = props;
  const ref = useRef(null);
  const isTaskMobile = useMatchTaskBreakpoint(taskBreakpoints.mobile);
  const isViewportMobile = useMatchBreakpoint(breakpoints.mobile);
  const isMobile = props.type === "results" ? isViewportMobile : isTaskMobile;
  const component = useOpgavekompleksetComponent();
  const onFinish = useFinishAction();
  const {
    fullscreenEnabled,
    fullscreenSupported
  } = useFullscreenState();
  const {
    handleFullscreenClick,
    handleExitFullscreenClick
  } = useOpgavekompleksetFullscreenActions(props);
  useElementSize(ref, {
    enabled: !!props.rootRef,
    applyTo: props.rootRef ?? null,
    axis: "vertical",
    varName: taskHeaderSize.propName
  });
  useKatex(ref, [props.type === "results" ? "resultater" : props.task?.id]);
  const title = props.type === "results" ? "Resultater fra opgavesættet" : getTaskTitle(props.task, {
    noFallback: true
  });
  const withProgress = externalWithProgress && component.data.settings.progression !== "conditional";
  return /*#__PURE__*/jsxs("header", {
    ref: ref,
    className: cx(header, withProgress && "withProgress"),
    "data-empty": !withProgress && !title && props.type === "stack",
    children: [withProgress && /*#__PURE__*/jsx("div", {
      className: progress,
      children: /*#__PURE__*/jsx(Progress, {
        dimmed: props.type === "results",
        taskIndex: props.type === "results" ? component.data.tasks.length - 1 : props.taskIndex
      })
    }), /*#__PURE__*/jsx(TransitionGroup, {
      className: headingWrapper,
      children: /*#__PURE__*/jsx(SizeTransition, {
        axis: "vertical",
        swappable: true,
        timeout: transitionDurationMs,
        classNames: heading,
        retainClassnamesOnExit: true,
        children: ref => /*#__PURE__*/jsx("h4", {
          ref: ref,
          className: heading,
          children: /*#__PURE__*/jsx("span", {
            children: title || (withProgress ? " " : "")
          })
        })
      }, props.type === "results" ? "results" : props.task?.id)
    }), props.type !== "stack" && /*#__PURE__*/jsxs("div", {
      className: tools,
      children: [props.type !== "results" && !isMobile && /*#__PURE__*/jsx(LinkButton, {
        className: finishButton,
        theme: "inline",
        onClick: () => onFinish(),
        children: "Afslut og se resultat"
      }), fullscreenSupported && props.componentProps.context !== "lightbox" && !isMobile && /*#__PURE__*/jsxs(Fragment, {
        children: [!fullscreenEnabled && /*#__PURE__*/jsx(IconButton, {
          label: "G\xE5 til fuldsk\xE6rmsvisning",
          icon: /*#__PURE__*/jsx(EnterFullscreenIcon, {
            height: 22
          }),
          onClick: handleFullscreenClick
        }), fullscreenEnabled && /*#__PURE__*/jsx(IconButton, {
          label: "Luk fuldsk\xE6rmsvisning",
          tooltip: {
            ariaType: "label",
            placement: "top"
          },
          icon: /*#__PURE__*/jsx(ExitFullscreenIcon, {
            height: 22
          }),
          onClick: handleExitFullscreenClick
        })]
      })]
    })]
  });
}

export { TaskHeader };
//# sourceMappingURL=_task-header.js.map
